if (!customElements.get('taelleo-shipping-goal')) {
  customElements.define('taelleo-shipping-goal', class extends HTMLElement {
    connectedCallback() {
      this.price = Number(this.dataset.price);
      this.cart = null;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.onVariant = e => {
        if (String(e.detail?.data?.productId) !== this.dataset.product) return;
        if (e.detail.resource?.price != null) this.price = Number(e.detail.resource.price);
        this.update();
      };
      document.addEventListener('variant:update', this.onVariant, options);
      document.addEventListener('cart:update', () => this.refresh(), options);
      document.addEventListener('discount:update', () => this.refresh(), options);
      this.closest('.buy-buttons-block')?.addEventListener('change', () => this.update(), options);
      this.refresh();
    }
    disconnectedCallback() { this.controller?.abort(); }
    async refresh() {
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
        if (!response.ok) return;
        this.cart = await response.json();
        this.update();
      } catch { /* Keep the static USD threshold when cart data is unavailable. */ }
    }
    update() {
      const line = this.querySelector('[data-goal-message]');
      if (!line || !this.cart || this.cart.currency !== 'USD' || this.dataset.currency !== 'USD') return;
      const quantity = Math.max(1, Number(this.closest('.buy-buttons-block')?.querySelector('[name="quantity"]')?.value) || 1);
      const subtotal = Number(this.cart.total_price) || 0;
      if (subtotal >= 4900) line.textContent = '✓ Your cart qualifies for free shipping.';
      else if (subtotal + this.price * quantity >= 4900) line.textContent = '✓ Add this selection to qualify for free shipping.';
      else line.textContent = `Add US$${((4900 - subtotal - this.price * quantity) / 100).toFixed(2)} more with this selection for free shipping.`;
    }
  });
}
